import { useCallback, useEffect, useState } from "react";
import { isJwtExpired } from "@/lib/auth-client";
import { useAuth } from "@/contexts/AuthContext";

export function useRagAuthReady() {
  const { isLoading, user, getAccessToken, syncSession } = useAuth();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [checkVersion, setCheckVersion] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setReady(false);
      setError(null);
      return;
    }

    if (!user) {
      setReady(false);
      setError(null);
      return;
    }

    let cancelled = false;

    async function check() {
      setReady(false);
      setError(null);

      const token = await getAccessToken();
      if (cancelled) {
        return;
      }

      if (token && !isJwtExpired(token)) {
        setReady(true);
        return;
      }

      setError("Your session is not ready for KM yet. Please sign in again.");
    }

    void check();

    return () => {
      cancelled = true;
    };
  }, [isLoading, user, getAccessToken, checkVersion]);

  const retry = useCallback(async () => {
    await syncSession();
    setCheckVersion((version) => version + 1);
  }, [syncSession]);

  return { ready, error, retry };
}
